import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { convertTagNameToSlug } from '@util/blog';
import { useTranslations } from 'next-intl';

export type BlogPostProps = {
  key: string;
  img: string;
  alt_text: string;
  tags: any;
  headline: string;
  date: string;
  bodyText: string;
  url: string;
  urlPrepend?: string;
};

export const featuredArticlesMapping = (
  blogPostsData: BlogPostProps[],
  urlPrepend: string,
  t: ReturnType<typeof useTranslations>,
) => {
  const mappedBlogPosts = blogPostsData
    ?.filter((item: any) => item.fields)
    .map((item: any) => ({
      key: item.sys.id,
      img: item?.fields?.img?.fields?.file?.url,
      alt_text: item.fields?.img?.fields?.description ? item.fields?.img.fields.description : '',
      headline: item.fields?.title,
      date: item.sys.createdAt,
      bodyText: documentToPlainTextString(item.fields?.bodyText),
      slug: item.fields?.slug,
      urlPrepend: urlPrepend,
      tags: item.fields?.blogTags
        ? item.fields?.blogTags?.map((tag: any) => ({
            name: tag,
            slug: convertTagNameToSlug(tag),
          }))
        : [],
    }));

  //limit the bodyText to 300 characters
  mappedBlogPosts?.map((card) => {
    card.bodyText = card.bodyText.slice(0, 300);
  });

  return mappedBlogPosts;
};
